import React from 'react';
import '../../index.module.scss';
import styles from './subtotal.module.scss';
import { c } from '../../utils';
import { Price } from '../Price';
import { BasicComponentProps } from "../../types";

export type SubtotalLine = {
  label: string;
  price: string;
  originalPrice?: string;
  isProDiscount?: boolean;
  calculatedAtCheckout?: boolean;
} & BasicComponentProps;

export type SubtotalProps = {
  lines: SubtotalLine[];
} & BasicComponentProps;

export const Subtotal = ({
  lines,
  className,
  ...props
}: SubtotalProps) => (
  <div className={c(styles.subtotal, className)} {...props}>
    {lines?.map((line: SubtotalLine) => {
      const { label, calculatedAtCheckout, className: lineClassName, ...rest } = line;

      return (
        <div key={label} className={styles.line} aria-label={label}>
          <span className={styles.label}>{label}</span>
          {calculatedAtCheckout ? (
            <span className={styles.atCheckout}>Calculated at checkout</span>
          ) : (
            <Price
              className={c(styles.price, lineClassName)}
              {...rest}
            />
          )}
        </div>
      );
    })}
  </div>
);
